import {
  GameType,
  TrackingPageGameBlock,
} from "@redotech/redo-model/order-tracking/tracking-page-definition";
import { useEffect, useState } from "react";
import { CustomSprite, GameState } from "../game";
import { preprocessSpriteForAlignment } from "../util/preprocess-sprite";

export function useInitialSprites(
  blockProps: TrackingPageGameBlock,
  gameState: GameState,
) {
  const [playerSprite, setPlayerSprite] = useState<CustomSprite | null>(null);
  const [npcSprite, setNpcSprite] = useState<CustomSprite | null>(null);

  useEffect(() => {
    if (
      gameState === GameState.Welcome &&
      blockProps.gameType === GameType.TINY_PACKAGE &&
      blockProps.gameSettings
    ) {
      const loadInitialSprites = async () => {
        const playerSpriteUrl = blockProps.gameSettings.playerSpriteUrl;
        const playerSpriteSize = blockProps.gameSettings.playerSpriteSize || 32;
        const npcSpriteUrl = blockProps.gameSettings.npcSpriteUrl;
        const npcSpriteSize = blockProps.gameSettings.npcSpriteSize || 32;

        const [processedPlayerSprite, processedNpcSprite] = await Promise.all([
          playerSpriteUrl
            ? preprocessSpriteForAlignment(playerSpriteUrl, playerSpriteSize)
            : Promise.resolve(null),
          npcSpriteUrl
            ? preprocessSpriteForAlignment(npcSpriteUrl, npcSpriteSize)
            : Promise.resolve(null),
        ]);

        setPlayerSprite(processedPlayerSprite);
        setNpcSprite(processedNpcSprite);
      };

      loadInitialSprites().catch((error) => {
        console.error("Failed to load initial sprites:", error);
      });
    }
  }, [gameState, blockProps.gameType, blockProps.gameSettings]);

  return { playerSprite, npcSprite };
}
